var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('sequential-entrance',{attrs:{"fromTop":""}},[_c('PublicRoleCard')],1),_c('v-main',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('PublicRoleForm')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }